<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :footer="null"
    :mask-closable="false"
    @cancel="TipDialogVisible=false"
  >
    <div
      v-if="manageType==='transfer'"
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["498"]') }}<span class="gray-small-btn ml-16">{{ comDatas.comname }}</span></h2>
      <div class="d-tip-con">
        {{ tip[0] }}  <br>{{ tip[1] }} ？
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="triggerTransfer('transfer')"
        >
          {{ $t('message["466"]') }}
        </a-button>
        <a-button
          class="ml-16"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
    <div
      v-if="manageType==='dismiss'"
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["488"]') }} <span class="gray-small-btn ml-16">{{ comDatas.comname }}</span></h2>
      <div class="d-tip-con">
        {{ $t('message["519"]') }}？
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          :disabled="submiting"
          @click="triggerTransfer('dismiss')"
        >
          {{ $t('message["466"]') }}
        </a-button>
        <a-button
          class="ml-16"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    manageType: {
      type: String,
      default: ''
    },
    comDatas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    cId () {
      return this.comDatas.cid
    },
    tip () {
      return this.$t('message["1643"]').split('|')
    }
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    triggerTransfer (val) {
      this.$emit('triggerMethod', val)
      this.TipDialogVisible = false
    }
  }
}
</script>
